export const HELP_CENTER_IDS = {
  layout: {
    root: "help-center-layout-root",
    main: "help-center-layout-main",
    content: "help-center-content",
    footer: "help-center-layout-footer",
    footerMain: "help-center-layout-footer-main",
    footerPolicyLinks: "help-center-layout-footer-policy-links",
    footerLinksRow: "help-center-layout-footer-links-row",
    footerLinkTerms: "help-center-layout-link-terms",
    footerLinkPrivacy: "help-center-layout-link-privacy",
    footerLinkRefund: "help-center-layout-link-refund",
  },
  pageFrame: {
    hero: "help-center-page-frame-hero",
    heroContainer: "help-center-page-frame-hero-container",
    heroContent: "help-center-page-frame-hero-content",
    title: "help-center-page-frame-title",
    subtitle: "help-center-page-frame-subtitle",
    body: "help-center-page-frame-body",
  },
  content: {
    combined: "help-center-combined-content",
  },
  header: {
    root: "help-center-header-root",
    desktopNav: "help-center-header-desktop-nav",
    desktopItem: (itemId: string) =>
      `help-center-header-desktop-item-${itemId}`,
    desktopItemButton: (itemId: string) =>
      `help-center-header-desktop-item-button-${itemId}`,
    desktopDropdown: (itemId: string) =>
      `help-center-header-desktop-dropdown-${itemId}`,
    desktopDropdownList: (itemId: string) =>
      `help-center-header-desktop-dropdown-list-${itemId}`,
    desktopSubitem: (itemId: string, index: number) =>
      `help-center-header-desktop-subitem-${itemId}-${index}`,
    desktopSubitemLink: (itemId: string, index: number) =>
      `help-center-header-desktop-subitem-${itemId}-${index}-link`,
    desktopSubitemBox: (itemId: string, index: number) =>
      `help-center-header-desktop-subitem-${itemId}-${index}-box`,
    mobileItem: (itemId: string) => `help-center-header-mobile-item-${itemId}`,
    mobileItemTrigger: (itemId: string) =>
      `help-center-header-mobile-item-trigger-${itemId}`,
    mobileItemPanel: (itemId: string) =>
      `help-center-header-mobile-item-panel-${itemId}`,
    mobileItemList: (itemId: string) =>
      `help-center-header-mobile-item-list-${itemId}`,
    mobileSubitem: (itemId: string, index: number) =>
      `help-center-header-mobile-subitem-${itemId}-${index}`,
  },
  about: {
    section: "help-center-about-section",
    labelRow: "help-center-about-label-row",
    labelBar: "help-center-about-label-bar",
    label: "help-center-about-label",
    title: "help-center-about-title",
    grid: "help-center-about-grid",
    cardDebug: (index: number) => `help-center-about-card-${index}`,
    cardTag: (index: number) => `help-center-about-card-tag-${index}`,
    cardTitle: (index: number) => `help-center-about-card-title-${index}`,
    cardBody: (index: number) => `help-center-about-card-body-${index}`,
  },
  guide: {
    section: "help-center-guide-section",
    introDebug: "help-center-guide-intro",
    introLabelRow: "help-center-guide-intro-label-row",
    introLabelBar: "help-center-guide-intro-label-bar",
    introLabel: "help-center-guide-intro-label",
    introTitle: "help-center-guide-intro-title",
    introCard: "help-center-guide-intro-card",
    introDescription: "help-center-guide-intro-description",
    introFeaturesTitle: "help-center-guide-intro-features-title",
    introFeaturesGrid: "help-center-guide-intro-features-grid",
    introFeature: (index: number) => `help-center-guide-feature-${index}`,
    showcaseDebug: "help-center-guide-showcase",
    showcaseLabelRow: "help-center-guide-showcase-label-row",
    showcaseLabelBar: "help-center-guide-showcase-label-bar",
    showcaseLabel: "help-center-guide-showcase-label",
    showcaseTitle: "help-center-guide-showcase-title",
    showcaseDescription: "help-center-guide-showcase-description",
    showcaseVideoCard: "help-center-guide-showcase-video-card",
    showcaseVideoContent: "help-center-guide-showcase-video-content",
    showcaseVideoTitle: "help-center-guide-showcase-video-title",
    showcaseVideoPlayer: "help-center-guide-showcase-video-player",
    showcaseStatsGrid: "help-center-guide-showcase-stats-grid",
    showcaseStat: (key: string) => `help-center-guide-stat-${key}`,
  },
  policy: {
    section: "help-center-policy-section",
    labelRow: "help-center-policy-label-row",
    labelBar: "help-center-policy-label-bar",
    label: "help-center-policy-label",
    title: "help-center-policy-title",
    description: "help-center-policy-description",
    grid: "help-center-policy-grid",
    link: (index: number) => `help-center-policy-link-${index}`,
    card: (index: number) => `help-center-policy-card-${index}`,
    cardIcon: (index: number) => `help-center-policy-card-icon-${index}`,
    cardTitle: (index: number) => `help-center-policy-card-title-${index}`,
    cardDescription: (index: number) =>
      `help-center-policy-card-description-${index}`,
    cardReadmore: (index: number) =>
      `help-center-policy-card-readmore-${index}`,
    cardReadmoreText: (index: number) =>
      `help-center-policy-card-readmore-text-${index}`,
  },
  policyLayout: {
    hero: "help-center-policy-layout-hero",
    heroContainer: "help-center-policy-layout-hero-container",
    breadcrumb: "help-center-policy-layout-breadcrumb",
    linkHome: "help-center-policy-layout-link-home",
    breadcrumbTitle: "help-center-policy-layout-breadcrumb-title",
    heroContent: "help-center-policy-layout-hero-content",
    title: "help-center-policy-layout-title",
    lastUpdated: "help-center-policy-layout-last-updated",
    contentContainer: "help-center-policy-layout-content-container",
    content: "help-center-policy-layout-content",
  },
  terms: {
    intro: "help-center-terms-intro",
    sections: "help-center-terms-sections",
    section: (index: number) => `help-center-terms-section-${index}`,
  },
  privacy: {
    intro: "help-center-privacy-intro",
    sections: "help-center-privacy-sections",
    section: (index: number) => `help-center-privacy-section-${index}`,
  },
  refund: {
    intro: "help-center-refund-intro",
    sections: "help-center-refund-sections",
    section: (index: number) => `help-center-refund-section-${index}`,
  },
  sectionHeader: {
    root: "help-center-section-header-root",
    container: "help-center-section-header-container",
    content: "help-center-section-header-content",
    title: "help-center-section-header-title",
    subtitle: "help-center-section-header-subtitle",
  },
} as const;
